import { Component, OnInit } from '@angular/core';
import { ModuloEnum } from '../../../shared/enums/modulo.enum';
import { FuncionalidadeEnum } from '../../../shared/enums/funcionalidade.enum';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AlertService, AlertType } from '../../../shared/services/alert.service';
import { MenuComponent } from '../../../shared/components/menu/menu.component';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatSelectModule } from '@angular/material/select';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { RelatorioResponse } from '../../../shared/services/responses/relatorio-interno/relatorio.response';
import { ListaEmpresaAdminResponse } from '../../../shared/services/responses/usuario/lista-empresa-admin.response';
import { ListaUsuarioResponse } from '../../../shared/services/responses/usuario/lista-usuario.response';
import { UsuarioAdminService } from '../../../shared/services/apis/usuario/usuario-admin.service';
import { SuperAcessoService } from '../../../shared/services/apis/usuario-admin/super-acesso.service';
import { SuperAcessoStruct } from '../../../shared/services/structs/usuario-admin/super-acesso.struct';

import { environment } from '../../../../environments/environment';
import { SuperAcessoRequest } from '../../../shared/services/requests/usuario-admin/super-acesso.request';
import { requiredTrim } from '../../../shared/validators/string-trim.validator';
import { SelectPesquisavelComponent } from '../../../shared/components/select-pesquisavel/select-pesquisavel.component';

@Component({
  selector: 'app-super-acesso-cadastro',
  imports: [
    MenuComponent,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatSelectModule,
    RouterModule,
    SelectPesquisavelComponent,
  ],
  providers: [],
  templateUrl: './super-acesso-cadastro.component.html',
  styleUrl: './super-acesso-cadastro.component.css',
})
export class SuperAcessoCadastroComponent implements OnInit {
  public moduloEnum: ModuloEnum;
  public funcionalidadeEnum: FuncionalidadeEnum;

  constructor(
    private formBuilder: FormBuilder,
    private usuarioAdminService: UsuarioAdminService,
    private superAcessoService: SuperAcessoService,
    private alertService: AlertService,
    private activatedRoute: ActivatedRoute,
    private router: Router
  ) {
    this.moduloEnum = ModuloEnum.Suporte;
    this.funcionalidadeEnum = FuncionalidadeEnum.Suporte_SuperAcesso;
  }

  public model: FormGroup;
  public _isLoading: boolean = false;
  public _empresaLookupResponse: ListaEmpresaAdminResponse;
  public _usuarioLookupResponse: ListaUsuarioResponse;
  public _relatorioResponse: RelatorioResponse;
  public idRelatorio: number | null = null;

  public isLinkAcessivel: boolean = true;
  public temporizadorMensagem: string = '';
  private timerExibido: any;
  private timer: any;
  private tempoLimite: number = 60000; //Tempo limite em milissegundos (1 minuto)
  public _urlListEmpresa: string;
  public preloadedEmpresa: any;

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.paramMap.get('idRelatorio')) {
      this.idRelatorio = parseInt(this.activatedRoute.snapshot.paramMap.get('idRelatorio') ?? '');
    }
    this._urlListEmpresa = environment.urlApiUsuario + 'ListaEmpresaAdmin';
    this.model = this.formBuilder.group({
      listaIdUsuario: new FormControl({ value: '', disabled: true }, [Validators.required]),
      descricaoAcesso: new FormControl({ value: '', disabled: false }, [Validators.required, requiredTrim]),
      listaIdEmpresa: new FormControl({ value: '', disabled: false }, [Validators.required]),
      linkSuperAcesso: new FormControl({ value: '', disabled: false }),
    });
  }

  async popularDadosUsuario(idEmpresa: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.usuarioAdminService.get(idEmpresa).subscribe({
        next: (listaUsuarioResponse: ListaUsuarioResponse) => {
          if (listaUsuarioResponse.isError) {
            this.alertService.show('Erro', listaUsuarioResponse.errorDescription, AlertType.error);
            return;
          }
          this._usuarioLookupResponse = listaUsuarioResponse;
          resolve();
        },
        error: (error: any) => {
          this.alertService.show('Erro inesperado', error, AlertType.error);
          reject();
        },
      });
    });
  }

  submit(): void {
    if (this._isLoading || this.model.invalid) {
      return;
    }
    const criaSuperAcessoRequest: SuperAcessoRequest = new SuperAcessoRequest();
    criaSuperAcessoRequest.idEmpresa = this.model.get('listaIdEmpresa')?.value;
    criaSuperAcessoRequest.idUsuario = this.model.get('listaIdUsuario')?.value;
    criaSuperAcessoRequest.descricao = this.model.get('descricaoAcesso')?.value.trim();
    this.novo(criaSuperAcessoRequest);
  }

  private novo(criaSuperAcessoResquest: SuperAcessoRequest): void {
    this._isLoading = true;
    this.superAcessoService.Incluir(criaSuperAcessoResquest).subscribe({
      next: (superAcessoStruct: SuperAcessoStruct) => {
        this._isLoading = false;
        if (superAcessoStruct.isError) {
          this.alertService.show('Erro', superAcessoStruct.errorDescription, AlertType.error);
          return;
        }
        this.alertService.show('Sucesso', 'Acesso gerado com sucesso.', AlertType.success);
        this.model
          .get('linkSuperAcesso')
          ?.setValue(environment.urlUi + '?token=' + superAcessoStruct.superAcesso.token);

        this.resetarContador();
      },
      error: (error: any) => {
        this._isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      },
    });
  }

  public async habilitaSelecaoUsuario(): Promise<void> {
    this.model.get('listaIdUsuario')?.enable();
    const idEmpresa = this.model.get('listaIdEmpresa')?.value;
    this.model.get('listaIdUsuario')?.setValue(null);

    if (idEmpresa) {
      await this.popularDadosUsuario(idEmpresa);
    }

    this.model.get('listaIdUsuario')?.enable();
  }

  private resetarContador(): void {
    this.isLinkAcessivel = true;

    if (this.timer) {
      clearTimeout(this.timer);
    }
    if (this.timerExibido) {
      clearInterval(this.timerExibido);
    }

    let totalSegundos = this.tempoLimite / 1000;

    const atualizarMensagem = (segundosTotais: number): void => {
      const minutos = Math.floor(segundosTotais / 60);
      const segundos = segundosTotais % 60;
      this.temporizadorMensagem =
        'Tempo restante: ' +
        (minutos > 0 ? `${minutos} minuto(s) e ${segundos} segundos` : `${segundos} segundos`);
    };

    atualizarMensagem(totalSegundos); // Mensagem inicial

    this.timerExibido = setInterval(() => {
      totalSegundos--;

      if (totalSegundos < 0) {
        clearInterval(this.timerExibido);
        return;
      }

      atualizarMensagem(totalSegundos);
    }, 1000);

    this.timer = setTimeout(() => {
      this.isLinkAcessivel = false;
      this.temporizadorMensagem = '';
      clearInterval(this.timerExibido);
    }, this.tempoLimite);
  }

  copiarLink(): void {
    const link = this.model.get('linkSuperAcesso')?.value;

    if (link) {
      navigator.clipboard
        .writeText(link)
        .then(() => {
          this.alertService.show('Sucesso', 'Link copiado para a área de transferência!', AlertType.success);
        })
        .catch(() => {
          this.alertService.show('Erro', 'Falha ao copiar o link.', AlertType.error);
        });
    } else {
      this.alertService.show('Erro', 'Link não encontrado.', AlertType.error);
    }
  }

  abrirLink(): void {
    const link = this.model.get('linkSuperAcesso')?.value;

    if (link) {
      window.open(link, '_blank');
      this.isLinkAcessivel = false;
    } else {
      this.alertService.show('Erro', 'Link não encontrado.', AlertType.error);
    }
  }

  limpaCampos(): void {
    this.model.get('listaIdEmpresa')?.setValue(null);
    this.model.get('listaIdUsuario')?.setValue(null);
    this.model.get('listaIdUsuario')?.disable();
    this.model.get('descricaoAcesso')?.setValue(null);
    this.model.get('linkSuperAcesso')?.setValue('');
    this.temporizadorMensagem = '';
    this.isLinkAcessivel = false;
    clearTimeout(this.timer);
    clearInterval(this.timerExibido);
  }

  public get listaIdEmpresaControl(): FormControl {
    return this.model.get('listaIdEmpresa') as FormControl;
  }
}
